(() => {
  'use strict';
    const limites = [500, 1000, 1500, 2000, 3000, 3500, 4000, Infinity];
  const format = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const euros = value => format.format(value / 100);
  let sourcePromise;
  let version = 0;
  let configuration = {};
  try {
    configuration = JSON.parse(document.querySelector('[data-sbc-cadeaux-config]')?.textContent || '{}');
  } catch (_) {}
  const promotionRelais = pays => window.SbcPanierDecision?.promotionLivraisonRelais(configuration, pays, Date.now()) === true;

  function lire(root) {
    const tarifs = new Map();
    root.querySelectorAll('[data-sbc-country][data-sbc-rates]').forEach(row => {
      try {
        const labels = Array.from(row.cells[1].children, node => node.textContent.trim());
        const methods = row.dataset.sbcRates.split('|').map((text, index) => {
          const [key, amounts] = text.split('=');
          return { key, label: labels[index], prices: amounts.split(',').map(value => value === '_' ? null : Number(value)) };
        });
        const parts = row.dataset.sbcFree && row.dataset.sbcFree.split('=');
        const free = parts ? { key: parts[0], threshold: Number(parts[1]), maxTestedWeight: Number(parts[2]), label: row.dataset.sbcFreeLabel } : null;
        tarifs.set(row.dataset.sbcCountry, { name: row.cells[0].textContent.trim(), methods, free });
      } catch (_) {}
    });
    return tarifs;
  }

  async function catalogue() {
    const present = lire(document);
    if (present.size) return present;
    if (!sourcePromise) {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      sourcePromise = fetch(root + 'pages/livraison-delais', { credentials: 'same-origin', cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error('Livraison indisponible');
          return response.text();
        })
        .then(html => lire(new DOMParser().parseFromString(html, 'text/html')))
        .catch(() => { sourcePromise = null; return new Map(); });
    }
    return sourcePromise;
  }

  function estimation(entry, poids, total, devise, pays) {
    if (devise !== 'EUR') return [];
    const promoRelais = promotionRelais(pays);
    if (!entry || !(poids > 0)) return promoRelais ? [{ key: entry?.free?.key || 'shipping', label: entry?.free?.label || 'Livraison éligible', cents: 0 }] : [];
    const index = limites.findIndex(max => poids <= max);
    const values = new Map();
    if (index >= 0) entry.methods.forEach(method => {
      const cents = method.prices[index];
      if (Number.isInteger(cents) && cents >= 0) values.set(method.key, { key: method.key, label: method.label, cents });
    });
    const free = entry.free;
    if (free && total >= free.threshold && poids <= free.maxTestedWeight) {
      values.set(free.key, { key: free.key, label: free.label, cents: 0 });
    }
    if (promoRelais) {
      values.set(free?.key || 'shipping', { key: free?.key || 'shipping', label: free?.label || 'Livraison éligible', cents: 0 });
    }
    return Array.from(values.values());
  }

  function afficher(noeud, rates, limite = false) {
    const meilleur = rates.reduce((minimum, rate) => !minimum || rate.cents < minimum.cents ? rate : minimum, null);
    const texte = limite
      ? (meilleur ? (meilleur.cents === 0 ? 'Offerte' : euros(meilleur.cents)) : '—')
      : (rates.length ? rates.map(rate => rate.label + ' : ' + (rate.cents === 0 ? 'offerte' : euros(rate.cents))).join(' · ') + ' (estimation)' : 'Calculée au paiement');
    if (noeud.textContent !== texte) noeud.textContent = texte;
    if (limite) {
      const destination = noeud.dataset.paysNom || noeud.dataset.pays;
      const precision = meilleur
        ? 'Estimation pour ' + destination + ' · ' + meilleur.label + '. Montant définitif confirmé au paiement selon l’adresse et les remises.'
        : 'Estimation indisponible. Montant confirmé au paiement selon l’adresse et les remises.';
      noeud.title = precision;
      noeud.setAttribute('aria-label', texte + '. ' + precision);
    }
  }

  async function actualiser(event) {
    const widgets = Array.from(document.querySelectorAll('[data-sbc-page-estimation]'));
    const resumes = Array.from(document.querySelectorAll('[data-sbc-estimation-livraison]'));
    if (!widgets.length && !resumes.length) return;
    const courant = ++version;
    if (widgets.length && event && /sbc:cart-updated|sbc:section-rendue/.test(event.type)) {
      try {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Panier indisponible');
        const cart = await response.json();
        if (courant !== version) return;
        widgets.forEach(widget => {
          widget.dataset.poids = String(cart.total_weight);
          widget.dataset.total = String(cart.total_price);
          widget.dataset.nombre = String(cart.item_count);
          widget.dataset.devise = cart.currency;
        });
      } catch (_) {
        widgets.forEach(widget => {
          const output = widget.querySelector('[data-sbc-page-estimation-resultat]');
          if (output) output.textContent = 'Retrouvez le montant exact au paiement.';
        });
        return;
      }
    }
    const tarifs = await catalogue();
    if (courant !== version) return;
    resumes.forEach(noeud => {
      if (!noeud.isConnected) return;
      const pays = String(noeud.dataset.pays || 'FR').toUpperCase();
      afficher(noeud, estimation(tarifs.get(pays), Number(noeud.dataset.poids), Number(noeud.dataset.total), String(noeud.dataset.devise || 'EUR').toUpperCase(), pays), true);
      const libelle = noeud.closest('.cart-summary__row--livraison')?.querySelector('[data-sbc-livraison-libelle]');
      if (libelle) libelle.textContent = promotionRelais(pays) ? 'Livraison' : 'Livraison estimée';
    });
    widgets.forEach(widget => {
      const select = widget.querySelector('select');
      const output = widget.querySelector('[data-sbc-page-estimation-resultat]');
      const recap = widget.querySelector('[data-sbc-page-estimation-panier]');
      if (!select || !output) return;
      if (select.options.length < 2 && tarifs.size) {
        const selected = widget.dataset.pays || 'FR';
        select.replaceChildren(...Array.from(tarifs, ([code, entry]) => {
          const option = document.createElement('option');
          option.value = code;
          option.textContent = entry.name;
          option.selected = code === selected;
          return option;
        }).sort((a, b) => a.textContent.localeCompare(b.textContent, 'fr')));
        if (!tarifs.has(selected)) select.value = 'FR';
      }
      const rendre = () => {
        const nombre = Number(widget.dataset.nombre);
        const total = Number(widget.dataset.total);
        const poids = Number(widget.dataset.poids);
        const devise = String(widget.dataset.devise || 'EUR').toUpperCase();
        if (!nombre) {
          recap.textContent = 'Votre panier est vide.';
          output.textContent = 'Ajoutez des articles pour afficher une estimation.';
          return;
        }
        recap.textContent = nombre + ' article' + (nombre > 1 ? 's' : '') + ' · ' + (devise === 'EUR' ? euros(total) + ' · ' : '') + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 3 }).format(poids / 1000) + ' kg';
        afficher(output, estimation(tarifs.get(select.value), poids, total, devise, select.value));
      };
      if (!select.dataset.sbcLie) {
        select.addEventListener('change', () => actualiser());
        select.dataset.sbcLie = 'true';
      }
      rendre();
    });
  }

  document.addEventListener('DOMContentLoaded', actualiser);
  document.addEventListener('sbc:section-rendue', actualiser);
  document.addEventListener('sbc:cart-updated', actualiser);
  if (document.readyState !== 'loading') actualiser();
  window.SbcEstimationLivraison = { actualiser, catalogue, estimation, promotionActive: promotionRelais };
})();

